import React, { useState, useEffect } from "react";
import { Button, TextField } from "@mui/material";
import Modal from "../../../../components/Modal/Modal";
import { useFetch } from "use-http";

const SubjectFormModal = ({ open, onClose, subject, revalidator }) => {
  const [name, setName] = useState("");

  const { post } = useFetch();

  useEffect(() => {
    if (subject) {
      setName(subject.name);
    }
  }, [subject]);

  const handleSubmit = async () => {
    await post("/subjects/create", { name: name });
    revalidator.revalidate();
    onClose();
  };

  const handleClose = () => {
    setName("");
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      title={subject ? "Editar materia" : "Adicionar materia"}
      children={
        <>
          <TextField
            label="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            fullWidth
            margin="normal"
          />
        </>
      }
      actions={
        <>
          <Button onClick={handleClose} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSubmit} color="primary">
            {subject ? "Atualizar" : "Adicionar"}
          </Button>
        </>
      }
    />
  );
};

export default SubjectFormModal;
